@if (canReset) {
<div class="reset-renderer">
  @if (!resetting) {
  <button (click)="resetOrder()" class="reset-button">Reset</button>
  } @if (resetting) {
  <span class="resetting">Resetting...</span>
  }
</div>
}
